import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { utils } from '@atlaskit/util-service-support';
export function fetchRestResponse(_x) {
  return _fetchRestResponse.apply(this, arguments);
}
function _fetchRestResponse() {
  _fetchRestResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var url, body, options;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = _ref.url, body = _ref.body;
          options = {
            requestInit: {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(body)
            }
          };
          return _context.abrupt("return", utils.requestService({
            url: url
          }, options));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchRestResponse.apply(this, arguments);
}